import { i18n as I18n } from './i18n';

export const goBackText = returnType => {
  return I18n.t(`back_buttons.${returnType}`);
};

export const scrollIntoViewWithOffset = (selector, offset) => {
  window.scrollTo({
    top:
      document.querySelector(selector).getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  });
};
